import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';

import { defaultSiteState, siteReducer, SiteState } from './site/reducer';
import {
    defaultStoryblokState,
    storyblokReducer,
    StoryblokState,
} from './storyblok/reducer';
import { defaultUserState, userReducer, UserState } from './user/reducer';

export interface ApplicationState {
    site: SiteState;
    storyblok: StoryblokState;
    user: UserState;
}

export type ApplicationStore = Store<ApplicationState>;

export const initialState = {
    site: defaultSiteState,
    user: defaultUserState,
    storyblok: defaultStoryblokState,
};

export const configureStore = (): ApplicationStore => {
    return createStore(
        combineReducers({
            storyblok: storyblokReducer,
            user: userReducer,
            site: siteReducer,
        }),
        /**
         * ComposeWithDevTools is needed to make Redux Dev Tools work in
         * browser.
         */
        composeWithDevTools(applyMiddleware(ReduxThunk)),
    );
};
